export enum EventNameEnum {
    FormInstance_Workflow_Transition = 'FormInstance_Workflow_Transition',
    FormInstance_Added_To_Folder = "FormInstance_Added_To_Folder",
    FormInstance_Manually_Triggered = "FormInstance_Manually_Triggered"
}
